export const ru = {
    'popular-current-streams': 'Популярные текущие трансляции',
    'title-streams': 'Трансляции',
    'no-streams': 'Пока нет активных трансляций',
    'no-streams-description': 'Здесь будет отображаться список всех доступным вам трансляций',
    'upcoming-streams': 'Запланированные трансляции',
};
